import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Roles } from '@shared/models/types';
import { UserFilterURL, UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerPartnerService extends UserService {
  constructor(activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  override set filters(value: UserFilterURL) {
    const customerPartnerFilters = { ...value, role: Roles.CUSTOMER_PARTNER };
    super.filters = customerPartnerFilters;
  }

  initializeCustomerPartners() {
    this.filters = { role: Roles.CUSTOMER_PARTNER };
  }
}
